export const APP_PROMPTS = {
  IN_APP_REDIRECTION: "inAppDeepLink://",
  BAJAJ_SUPER_APP: "bajajsuperapp://",
  OPEN_APP_LOADER: "OpenProgressDialog",
  OPEN_PDF: "OpenPDF://",
  APP_SEARCH: "PWA_Search",
  HOMEPAGE: "HOMEPAGE",
  MY_ACCOUNT: "myAccount_PWA",
  CART: "cart",
  HAMBURGER: "hamburger",
  APP_VERSION: "getAppVersion://",
  GET_PDF_FROM_BASE64: "getpdffrombase64://",
  PAYMENT_SDK: "callcheckout://",
  CREATE_LOAD_MODULE: "CreateLoadModule://",
  GET_APP_TOKEN: "refreshToken", // string value is confusing here - RefreshToken is a prompt for getting the app token & not meant for refreshing token
  HARD_REFRESH_APP_TOKEN: "hardRefreshToken",
  SHARED_PREF: "SharedPref://",
  SHARE_APP: "ShareApp",
  OPEN_DIAL: "openDial://",

  CUSTOMER_DEMOG_DETAILS: "customerdemoapidata",

  // ✅ Newly added prompt
  OPEN_EXTERNAL_BROWSER: "openExternalBrowser://",
  SHOW_WEB_URL: "showWebURL",
  CUSTOMER_RELATIONSHIP_DETAILS: "customerrealtionshipapidata",
  ICORS_OFFER_DETAILS: "offerapidata",
  GO_BACK_TO_3IN1: "gobackto3in1",
  SHOW_MONETIZATION_URL: "showmonetisationurl",
  SHOW_MONETIZATION_URL_APP: "showmonetisationurlinapp",
  GET_ADVERTISING_ID: "getadvertisingidentifier",
} as const;
